<template>
    <div class="collectList">
        <div class="emptyList" v-if="!collectList.length"><p>暂无数据</p></div>
        <div v-else class="collectItem" v-for="(item,index) in collectList" :key="index">
            <router-link tag="a" target="_blank" :to="'/resource/detail?rscId=' + item.rscID" class="fileImg"
                         :class="fileClass(item.rscFileType)">
                <div class="imgMask"><i></i></div>
                <img :src="item.rscImage ? item.rscImage : '/styles/rescover.png'"/>
            </router-link>
            <div class="collect_product">
                <h3 class="title">{{ item.title }}</h3>
                <p class="description">{{ item.rscDesc }}</p>
                <ul class="tags">
                    <li v-for="(tag,index) in item.tags" :key="index">{{ tag }}</li>
                </ul>
                <div class="bottom">
                    <ul>
                        <li class="downNum"><span>{{item.downNum}}</span></li>
                        <li class="favorite"><span>{{ item.favNum }}</span></li>
                        <li class="time"><span>{{ item.collectTime }}</span></li>
                        <li class="people"><span>{{ item.realName }}</span></li>
                    </ul>
                </div>
            </div>
        </div>
        <el-pagination v-if="collectList && collectList.length"
                       :current-page="pageNum"
                       layout="prev, pager, next"
                       :total="total"
                       background
                       :page-size="pageSize"
                       prev-text="上一页"
                       next-text="下一页"
                       @current-change="handleCurrentChange"
        />
    </div>
</template>

<script>
  import { getCollectListApi } from '@/api/collect';
  import { $Cookies } from '@/utils';

  export default {
    name: 'CollectTab',
    props: {
      activeIndex: {
        type: String,
        default: '0'
      }
    },
    data () {
      return {
        collectList: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
        resImage: ''
      };
    },
    watch: {
      activeIndex: function () {
        this.getColletList();
      }
    },
    async mounted () {
      await this.getColletList();
    },
    methods: {
      async getColletList () {
        const uid = $Cookies.get('uid');
        const params = {
          userNo: Number(uid),
          rscFileType: this.activeIndex,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        };
        await getCollectListApi(params).then(data => {
          if (data.success) {
            const { list, pageNum, pageSize, total } = data.result;
            this.pageNum = pageNum;
            this.pageSize = pageSize;
            this.total = total;
              if(list.length){
               list.map((item)=>{
              const tags = item.tags.length > 5 ? item.tags.slice(0,5) : item.tags;
              for(let i =0;i<tags.length;i++){
                if(tags[i].length > 10){
                  const item = tags[i].substr(0, 9) + '...';
                  tags[i] = item;
                }
              }
              item.tags = tags;
              return item;
            })
          }
            this.collectList = list;
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      },
      fileClass (type) {
        let className = '';
        if (type === 1 || type === 3) {
          className = 'resDoc';
        } else if (type === 2) {
          className = 'resVideo';
        } else if (type === 4) {
          className = 'resAudio';
        }
        return className;
      },
      handleCurrentChange (size) {
        this.pageNum = size;
        this.getColletList();
      },
    }
  };
</script>
